module.exports = __webpack_public_path__ + "media/images/brussels/confirmation/confirmation-image-2@2x-d8923f5efe218d828685857038a70701.png";